<template>
  <div class="empty-offer">
    <div class="empty-offer-item">
      <div class="empty-item-left">
        <div class="empty-item-left-top" />
        <div class="empty-item-left-bottom">
          <div
            v-for="item in new Array(6).fill(0)"
            class="empty-item-selecton"
            key="item"
          />
        </div>
      </div>
      <div class="empty-item-center">
        <div class="empty-item-center-1">
          <div class="left">
            <div
              class="skeleton"
              style="width: 68px; height: 24px;"
            />
            <div
              class="skeleton"
              style="width: 280px; height: 24px;"
            />
            <div
              class="skeleton"
              style="width: 200px; height: 24px;"
            />
            <div
              class="skeleton"
              style="width: 275px; height: 24px;"
            />
          </div>
          <div class="right">
            <div
              class="skeleton circle"
              style="width: 32px; height: 32px;"
            />
          </div>
        </div>
        <div class="empty-item-center-2" />
        <div class="empty-item-center-3" />
        <div class="empty-item-center-4">
          <div class="skeleton" />
          <div class="circle-warpper">
            <div class="circle" />
            <div class="circle" />
            <div class="circle" />
            <div class="circle" />
          </div>
        </div>
        <div class="empty-item-center-5">
          <div class="skeleton s1" />
          <div class="skeleton-wrapper">
            <div class="skeleton s2" />
            <div class="skeleton s2" />
          </div>
        </div>
      </div>
      <div class="empty-right" />
    </div>
  </div>
</template>

<script setup>
</script>

<style lang="less" scoped>
.empty-offer {
  padding-top: 24px;

  @keyframes gradient {
    0% {
      background-color: #EBEBEB;
    }
    25% {
      background-color: #F8F8F8;
    }
    80% {
      background-color: #EBEBEB;
    }
    100% {
      background-color: #EBEBEB;
    }
  }

  .skeleton {
    border-radius: 4px;
    animation: gradient 2s linear infinite;
    &.circle {
      border-radius: 50%;
    }
  }

  .empty-offer-item {
    display: flex;
    justify-content: space-between;
    gap: 24px;

    .empty-item-left {
      width: 360px;

      @media (min-width: 1280px) {
        width: 490px;
      }

      .empty-item-left-top {
        height: 490px;
        border-radius: 12px;
        animation: gradient 2s linear infinite;
      }

      .empty-item-left-bottom {
        display: flex;
        justify-content: space-between;
        gap: 10px;
        margin-top: 12px;

        .empty-item-selecton {
          width: 70px;
          height: 70px;
          border-radius: 4px;
          animation: gradient 2s linear infinite;
        }
      }
    }

    .empty-item-center {
      flex: 1;
      min-width: 390px;
      height: 590px;

      .empty-item-center-1 {
        display: flex;
        justify-content: space-between;
      }

      .empty-item-center-2 {
        height: 56px;
        border-radius: 4px;
        margin-top: 20px;
        animation: gradient 2s linear infinite;
      }

      .empty-item-center-3 {
        height: 0.5px;
        background-color: #EBEBEB;
        margin-top: 20px;
        margin-bottom: 20px;
      }

      .empty-item-center-4 {
        .skeleton {
          width: 120px;
          height: 18px;
          margin-bottom: 18px;
        }
        .circle-warpper {
          display: flex;
          padding: 4px;
          .circle {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            margin-right: 14px;
            animation: gradient 2s linear infinite;
          }
        }
      }

      .empty-item-center-5 {
        margin-top: 16px;
        .s1 {
          width: 120px;
          height: 18px;
        }
        .skeleton-wrapper {
          padding: 4px;
          margin-top: 12px;
          .s2 {
            height: 48px;
            margin-bottom: 12px;
          }
        }
      }
    }

    .empty-right {
      width: 286px;
      height: 494px;
      border-radius: 12px;
      animation: gradient 2s linear infinite;
    }
  }
}
</style>
